import React, { useState, useRef } from 'react'
import { Accordion, Button, Container, Form, FormControl, InputGroup, Nav, Row, Col, Tab, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import styles from './FAQs.module.scss';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { data } from '../data';
import { useHistory, useParams, useLocation } from 'react-router-dom'

const FAQsMain = () => {
    let loc = window.location.hash;
    loc = loc.slice(1);
    const history = useHistory();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState('');
    const [copied, setCopied] = useState(false);
    const [show, setShow] = useState(false);
    const [shown, setShown] = useState(false);
    const target = useRef(null);
    const [selectedTab, setSelectedTab] = useState(location.search.substring(1));
    const handleSelect = (e) => {
        //set state
        setSelectedTab(e);
        //update url
        history.replace({
            search: `${e}`
        });
    }
    const handleCopy = () => {
        setCopied(true);
    };

    const clickOnButton = () => {
        setShown(true);
    }

    const handleClick = (e) => {
        e.stopPropagation();
        setShow(!show);
        setShown(true);
        setTimeout(() => {
            setShown(false);
        }, 2000);
    };

    const handleClickIndex = (index) => {
        setShow(!show);
        setShown(index);
        setTimeout(() => {
            setShown(false);
        }, 2000);
    };

    const [hover, sethover] = useState(null);

    const handleStop = (e) => {
        e.stopPropagation();
    }

    const handleResetHover = (index) => {
        sethover(false);
    }

    const handleMouseEnter = (index) => {
        sethover(index);
        setTimeout(() => {
            sethover(false);
        }, 3000);
    }
    return (<>

        <Container className="outerContainer">
            <h1 className="centerText mb-4">Frequently Asked Questions</h1>
            <p>The Agency for Healthcare Research and Quality (AHRQ) Quality IndicatorsTM (QIs) are measures that organizations can apply to inpatient hospital data to assess and improve health care quality, identify areas that need further study and investigation, and track changes over time. The AHRQ QI modules represent aspects such as Prevention, Inpatient, Patient Safety, and Pediatric quality of care.</p>
        </Container>
        <Container className="outerContainer">
            <div className={styles.searchContainer}>
                <h3 className={styles.searchHeading}>Filter</h3>
                <Form className="flex">
                    <Form.Group className={styles.search} controlId="formBasicEmail">
                        <InputGroup className={styles.inputGroup}>
                            <FormControl className={styles.searchBox} placeholder="Please enter a search term (i.e. Software, Health, etc...)" onChange={event => { setSearchTerm(event.target.value) }} />
                            <Button className={styles.resetButton} type="reset" onClick={event => { setSearchTerm('') }}>Reset Search</Button>
                        </InputGroup>
                    </Form.Group>
                </Form>
            </div>
        </Container>
        <Container className='outerContainer'>
            <Tab.Container id="left-tabs-example" activeKey={selectedTab ? selectedTab : '1'} onSelect={(e) => handleSelect(e)}>
                <Row>
                    <Col md={3}>
                        <Nav variant="pills" className="flex-column">
                            {data.faqs.map((information, index) => (<>
                                {information.category && information.category.includes("main") ?
                                    <Nav.Item>
                                        <Nav.Link onClick={handleResetHover} eventKey={index + 1}>{information.faqtopic}</Nav.Link>
<hr className="divider-blue" />
                                    </Nav.Item>

                                    : null
                                }

                            </>))}
                            <Accordion className={styles.faqsPreviousReleasesAccordion} defaultActiveKey="0">
                                <Accordion.Item>
                                    <Accordion.Header className={styles.faqsPreviousReleasesHeader}>Previous Releases</Accordion.Header>
                                    <Accordion.Body>
                                        {data.faqs.map((information, index) => (<>
                                            {information.category && information.category.includes("previous") ?
                                                <Nav.Item>
                                                    <Nav.Link onClick={handleResetHover} eventKey={index + 1}>{information.faqtopic}</Nav.Link>
                                                    <hr className="divider-blue" />
                                                </Nav.Item>
                                                : null}

                                        </>))}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Nav>
                    </Col>
                    <Col md={9}>
                        {searchTerm == "" ? null : <h5>Showing results for: "{searchTerm}"</h5>}
                        {data.faqs.map((information, index) => (<>
                            <Tab.Content className={styles.tabContent}>
                                <Tab.Pane eventKey={index + 1}>
                                    {information.children.filter((child) => {
                                        if (searchTerm == "") {
                                            return child
                                        } else if (child.faqSubtopic.toLowerCase().includes(searchTerm.toLowerCase())) {
                                            return child
                                        }
                                        else if (child.faqanswer.toLowerCase().includes(searchTerm.toLowerCase())) {
                                            return child
                                        }
                                    }).map((child, index) => (<>
                                        {/*{information.children.map((child, index) => (<>*/}
                                        <Accordion id={child.tag} className={styles.faqsAccordion} eventKey={child.tag} defaultActiveKey={loc.length === 0 ? "empty" : loc}>
                                            <Accordion.Item eventKey={child.tag}>
                                                <Accordion.Header id={child.tag} >
                                                    <div className={styles.accordionHeading}>
                                                        <div className={styles.subTopicHeading}><div dangerouslySetInnerHTML={{ __html: child.faqSubtopic }} /></div>
                                                        <div ref={target}>
                                                            {hover === index ? <div className={styles.copyContainer}><i className="fa fa-check-circle flex"></i><div className={styles.copiedText + ' ' + "flex"}>Copied to Clipboard</div></div> :
                                                                <CopyToClipboard text={`${window.location.origin}` + `${window.location.pathname}` + "?" + `${selectedTab ? selectedTab : '1'}` + "#" + `${child.tag}`} onCopy={handleCopy}>
                                                                    <Button variant="link" className={styles.copyBtn} onClick={(e) => e.stopPropagation()}>
                                                                        <a onClick={() => handleMouseEnter(index)}>Share</a>
                                                                    </Button>
                                                                </CopyToClipboard>
                                                            }
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <Row className={styles.accordionContent}>
                                                        <Col md={12}>
                                                            <div dangerouslySetInnerHTML={{ __html: child.faqanswer }} className="accordionContent mb-3" />
                                                        </Col>
                                                    </Row>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </>))}
                                </Tab.Pane>
                            </Tab.Content>
                        </>))}
                    </Col>
                </Row>
            </Tab.Container>
            <hr />
            <div className={"centerText mt-3" + ' ' + styles.blueBox} >
                <h4>Technical Assistance</h4>
                <p className="mb-0">The support e-mail address for the AHRQ Quality Indicators is <a href="mailto: QIsupport@ahrq.hhs.gov">QIsupport@ahrq.hhs.gov</a>. The AHRQ Quality Indicators support team can also be reached by phone in the USA at (301) 427-1949. Messages are responded to within three business days.</p>

            </div>
            <hr />
            <div className={"centerText mt-3" + ' ' + styles.blueBox} >
                <h4>Email Updates</h4>
                <p className="mb-0"><a href="http://subscriptions.ahrq.gov/accounts/USAHRQ/subscriber/new?topic_id=USAHRQ_39">Sign up</a> for email updates to stay informed about modifications and enhancements to the Quality Indicators and other information related to the AHRQ Quality Indicators. By signing up, you will be notified by email when AHRQ announces the availability of new Quality Indicators, revisions to the software and related tools, as well as publications, reports and other related news.</p>
                <img className="envelope" src="/images/envelope-regular-black.png" /><a href="https://subscriptions.ahrq.gov/accounts/USAHRQ/subscriber/new?topic_id=USAHRQ_39" className={'bold'}> Sign up: Quality Indicators email updates</a>
            </div>
        </Container>
    </>)
}

export default FAQsMain;